<template>
  <div @keyup.enter.prevent="makeLogin">
    <UiFakeInputs />

    <div class="title"> Вход </div>

    <!-- Email input -->
    <form-group :validator="$v.form.email" :server-errors="serverError('email')">
      <template slot-scope="{ attributes }">
        <UiInputText
          ref="email"
          v-model="form.email"
          placeholder="Email"
          type="text"
          inputmode="email"
          autocapitalize="off"
          autocorrect="off"
          :class="attributes.class"
          @input="delayTouch($v.form.email, 'email')"
        >
        </UiInputText>
      </template>
    </form-group>

    <!-- Password input -->
    <form-group :validator="$v.form.password" :server-errors="serverError('password')">
      <template slot-scope="{ attributes }">
        <UiInputText
          id="current-password"
          ref="password"
          v-model="form.password"
          placeholder="Пароль"
          autocapitalize="off"
          autocorrect="off"
          type="password"
          :class="attributes.class"
          password-reveal
          autocomplete="current-password"
          @input="delayTouch($v.form.password, 'password')"
        />
      </template>
    </form-group>

    <div class="footer">
      <!-- `makeLogin` button -->
      <UiButton
        :disabled="tryLogin"
        :class="['button', 'is-blue', { 'is-loading': tryLogin }]"
        @click="makeLogin"
      >
        Войти
      </UiButton>

      <UiLink :to="{ name: 'reset' }"> Забыли пароль? </UiLink>
    </div>
  </div>
</template>

<script>
import UiInputText from '@/components/UiInputText.vue'
import UiButton from '@/components/UiButton.vue'
import UiFakeInputs from '@/components/UiFakeInputs.vue'
import UiLink from '@/components/UiLink.vue'

import { AuthService } from '@/services/auth.service'

import { required, email } from 'vuelidate/lib/validators'
import validationHelpers from '@/mixins/validationHelpers.js'

import { firstAvailable } from '@/router/util'

export default {
  components: {
    UiInputText,
    UiButton,
    UiFakeInputs,
    UiLink,
  },
  mixins: [validationHelpers],
  data() {
    return {
      tryLogin: false,
      form: {
        email: '',
        password: '',
      },
    }
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    /**
     * Login functional
     */
    async makeLogin() {
      this.$v.$touch()
      this.clearFormServerErrors()

      if (this.$v.$invalid) return

      try {
        this.tryLogin = true

        const { email, password } = this.form
        const { data } = await AuthService.makeLogin({ email, password })

        // If there is no token, then $emit next step — 2FA auth.
        if (!data.token) {
          this.$emit('continue-2fa', {
            ...data,
            ...this.form,
          })

          return
        }

        await this.$store.dispatch('user/getCurrent')

        await this.$router.push(this.$route.query.redirectFrom || { name: firstAvailable() })
      } catch (error) {
        this.tryLogin = false
        this.formServerErrors = error.formServerErrors

        if (error.status !== 422) {
          this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  @include createFlex(flexbox, nowrap, row, space-between, center, center);
}
</style>
